import React, { useContext, useState } from "react";
import {
  FaFacebook,
  FaInstagram,
  FaTiktok,
  FaUserCircle,
} from "react-icons/fa";
import logo from "../../assests/Images/Logo.png";
import { useLocation, useNavigate } from "react-router-dom";
import { GlobalStateContext } from "../../App";
import { BsArrowRight } from "react-icons/bs";

function Navbar({ token, setToken }) {
  const navigator = useNavigate();
  const [dataView, setDataView] = useState(false);
  const { globalState, setGlobalState } = useContext(GlobalStateContext);
  const userData = globalState?.userData;
  
  const location = useLocation()

  const splitName = (name) => {
    const words = name.split(" ");
    if (words.length === 1) {
      return words[0].charAt(0);
    } else {
      const firstCharacters = words.map((word) => word.charAt(0));
      return firstCharacters.join("");
    }
  };
  // return (
  //   <div>
  //     <nav className=" ">
  //       <div className="flex items-center justify-around">
  //         <div className="relative flex h-16 items-center justify-center flex-col ml-24">
  //           <div className="flex gap-2 justify-center items-center">
  //             <div className="w-48 h-38 transition-transform duration-300 hover:scale-110">
  //               <a href="/Customiser">
  //                 <img src={logo} alt="logo"></img>
  //               </a>
  //             </div>
  //           </div>
  //         </div>
  //         <div className="flex items-center space-x-1">
  //           <a
  //             href="https://www.facebook.com/ParifyPackagingltd/"
  //             className="text-[#F4F4F4] hover:text-white rounded-full p-1 bg-[#676767] transition-transform duration-300 hover:scale-110"
  //             target="_blank"
  //           >
  //             <FaFacebook className="rounded-full" />
  //           </a>

  //           <a
  //             href="https://www.instagram.com/ParifyPackagingltd/"
  //             className="text-[#F4F4F4] hover:text-white rounded-full p-1 bg-[#676767] transition-transform duration-300 hover:scale-110"
  //             target="_blank"
  //           >
  //             <FaInstagram className="rounded-full" />
  //           </a>
  //           <a
  //             href="https://www.tiktok.com/@parifypackaging"
  //             className="text-[#F4F4F4] hover:text-white rounded-full p-1 bg-[#676767] transition-transform duration-300 hover:scale-110"
  //             target="_blank"
  //           >
  //             <FaTiktok className="rounded-full" />
  //           </a>
  //           {
  //             userData ?
  //               <>
  //                 <a className="!ml-[30px] cursor-pointer" onClick={() => setDataView(!dataView)}>
  //                   {/* <FaUserCircle style={{ fontSize: '24px' }} /> */}
  //                   <div className="bg-black h-8 w-8 rounded-full text-white text-[16px] text-center flex justify-center items-center cursor-pointer">{splitName(userData?.name)}</div>
  //                 </a>
  //                 {
  //                   dataView &&
  //                   <div className="px-10 py-5 rounded-xl bg-white absolute top-[70px] right-[10vw] z-50">
  //                     <p className="text-2xl font-bold">{userData?.name}</p>
  //                     <p>{userData?.email}</p>
  //                     <p>{userData?.phone}</p>
  //                     <button className="mt-3 px-5 py-1 bg-[#0e5e5e] text-white rounded-2xl cursor-pointer"
  //                       onClick={() => {
  //                         localStorage.removeItem("access_token")
  //                         setToken(null)
  //                       }}
  //                     >Sign out</button>
  //                   </div>
  //                 }
  //               </>
  //               :
  //               <a className="!ml-[30px] px-5 py-1 bg-[#0e5e5e] text-white rounded-2xl cursor-pointer"
  //                 onClick={(e) => {
  //                   navigator("/login")
  //                 }}>Login</a>
  //           }
  //         </div>
  //       </div>
  //       <hr className="border=[#818181] w-3/4 mx-auto" />
  //     </nav>
  //   </div>
  // );
  return (
    <>
      <nav className="mx-[50px] lg:mx-[100px] relative h-[80px] border-b-[1px] border-[#676767] py-10">
      <div className="absolute top-[50%] left-[30px] hidden md:block translate-y-[-50%] flex items-center space-x-1">
          {
            localStorage.getItem("admin_access_token")
            &&
            <>
            <BsArrowRight/>
            <a className="!ml-[10px] hover:border-b-[1px] border-[#676767] transition-all duration-300 text-black cursor-pointer"
              onClick={(e) => {
                // e.preventDefault()
                navigator("/admin")
              }}>Admin Panal</a>
            </>
          }
        </div>
        <a
          className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]"
          href="/"
        >
          <img className="w-[200px]" src={logo} alt="logo"></img>
        </a>
        <div className="absolute top-[50%] right-[30px] translate-y-[-50%] flex items-center space-x-1">
          <a
            href="https://www.facebook.com/ParifyPackagingltd/"
            className="text-[#F4F4F4] hidden lg:block  hover:text-white rounded-full p-1 bg-[#676767] transition-transform duration-300 hover:scale-110"
            target="_blank"
          >
            <FaFacebook className="rounded-full" />
          </a>
          <a
            href="https://www.instagram.com/ParifyPackagingltd/"
            className="text-[#F4F4F4]  hidden lg:block hover:text-white rounded-full p-1 bg-[#676767] transition-transform duration-300 hover:scale-110"
            target="_blank"
          >
            <FaInstagram className="rounded-full" />
          </a>
          <a
            href="https://www.tiktok.com/@parifypackaging"
            className="text-[#F4F4F4]  hidden lg:block hover:text-white rounded-full p-1 bg-[#676767] transition-transform duration-300 hover:scale-110"
            target="_blank"
          >
            <FaTiktok className="rounded-full" />
          </a>
          {
            (userData && token) ?
              <>
                <a className="!ml-[30px] cursor-pointer" onClick={() => setDataView(!dataView)}>
                  {/* <FaUserCircle style={{ fontSize: '24px' }} /> */}
                  <div className="bg-black h-8 w-8 rounded-full text-white text-[16px] text-center flex justify-center items-center cursor-pointer">{splitName(userData?.name)}</div>
                </a>
              </>
              :
              <>
                <a className="!ml-[30px] px-5 py-1 bg-[#0E5E5E] text-white rounded-2xl cursor-pointer"
                  onClick={(e) => {
                    // e.preventDefault()
                    navigator("/login"+(location.pathname=="/customizer" ? "?redirect="+location.pathname+location.search : ""))
                  }}>Login</a>
                <a className="!ml-[10px] px-5 py-1  hidden lg:block bg-[#c7c7c7] text-black rounded-2xl cursor-pointer"
                  onClick={(e) => {
                    // e.preventDefault()
                    navigator("/register")
                  }}>Register</a>
              </>
          }
        </div>
      </nav>
      {
        dataView &&
        <div className="px-10 py-5 rounded-xl bg-white absolute top-[65px] right-[80px]">
          <p className="text-2xl font-bold">{userData.name}</p>
          <p>{userData.email}</p>
          <p>{userData.phone}</p>
          <button className="mt-3 px-5 py-1 bg-[#0E5E5E] text-white rounded-2xl cursor-pointer"
            onClick={() => {
              localStorage.removeItem("access_token")
              localStorage.removeItem("state")
              localStorage.removeItem("highestStage")
              localStorage.removeItem("rgs_email")
              setToken(null)
              setGlobalState(null)
            }}
          >Sign out</button>
        </div>
      }
    </>
  );
}

export default Navbar;
